(() => {
  const initProducts = (root) => {
    if (!root || root.dataset.productsReady === 'true') return;
    root.dataset.productsReady = 'true';

    const tabs = [...root.querySelectorAll('[data-product-tab]')];
    const sections = tabs
      .map((tab) => root.querySelector(tab.getAttribute('href')))
      .filter(Boolean);

    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        tabs.forEach((item) => item.classList.remove('is-active'));
        tab.classList.add('is-active');
        const target = root.querySelector(tab.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    const pageSize = Math.max(1, Number(root.dataset.productsPageSize || 6));
    const productGrids = [...root.querySelectorAll('[data-product-grid]')];
    productGrids.forEach((grid) => {
      const cards = [...grid.querySelectorAll('[data-product-card]')];
      const loadMoreWrap = grid.nextElementSibling?.matches('[data-load-more-wrap]') ? grid.nextElementSibling : null;
      const loadMoreButton = loadMoreWrap?.querySelector('[data-load-more]');
      let limit = pageSize;
      let filter = 'all';

      const updateGrid = (animate = false) => {
        const matching = cards.filter((card) => !card.matches('[data-cbd-card]') || filter === 'all' || card.dataset.cbdType === filter);
        cards.forEach((card) => {
          const position = matching.indexOf(card);
          const show = position !== -1 && position < limit;
          card.hidden = !show;
          card.classList.remove('is-filtering-in');
          if (show && animate) requestAnimationFrame(() => card.classList.add('is-filtering-in'));
        });
        if (loadMoreWrap) loadMoreWrap.hidden = matching.length <= limit;
        return matching.length;
      };

      grid.crocoSetFilter = (nextFilter) => {
        filter = nextFilter;
        limit = pageSize;
        return updateGrid(true);
      };
      grid.crocoRevealCard = (card) => {
        filter = 'all';
        const position = cards.indexOf(card);
        limit = Math.max(pageSize, position + 1);
        updateGrid(false);
      };
      loadMoreButton?.addEventListener('click', () => {
        limit += pageSize;
        updateGrid(true);
      });
      updateGrid(false);
    });

    const cbdFilters = [...root.querySelectorAll('[data-cbd-filter]')];
    const cbdGrid = root.querySelector('[data-cbd-grid]');
    const cbdEmpty = root.querySelector('[data-cbd-empty]');
    const filterCbd = (filter) => {
      cbdFilters.forEach((button) => {
        const active = button.dataset.cbdFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      const matching = cbdGrid?.crocoSetFilter?.(filter) || 0;
      if (cbdEmpty) cbdEmpty.hidden = matching !== 0;
    };
    cbdFilters.forEach((button) => button.addEventListener('click', () => filterCbd(button.dataset.cbdFilter)));

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = [...root.querySelectorAll('.cp-heading, .cp-card, .cp-online__heading, .cp-notice, .cp-cta, .cp-faq__heading, .cp-faq__list details')];
    revealItems.forEach((item, index) => {
      item.classList.add('cp-reveal');
      item.style.setProperty('--cp-delay', `${Math.min(index % 4, 3) * 70}ms`);
    });

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
      revealItems.forEach((item) => revealObserver.observe(item));
    }

    const faqItems = [...root.querySelectorAll('.cp-faq details')];
    faqItems.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        faqItems.forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      });
    });

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (!visible) return;
      tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.getAttribute('href') === `#${visible.target.id}`);
      });
    }, { rootMargin: '-20% 0px -65% 0px', threshold: [0, .15, .35] });

    sections.forEach((section) => observer.observe(section));
  };

  document.querySelectorAll('[data-croco-products]').forEach(initProducts);
  document.addEventListener('shopify:section:load', (event) => {
    initProducts(event.target.querySelector('[data-croco-products]'));
  });
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest?.('[data-croco-products]');
    const card = event.target.matches?.('[data-product-card]') ? event.target : event.target.querySelector?.('[data-product-card]');
    if (!root || !card) return;
    if (card.matches('[data-cbd-card]')) root.querySelector('[data-cbd-filter="all"]')?.click();
    card.closest('[data-product-grid]')?.crocoRevealCard?.(card);
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
